import React from 'react';
import { SmartCardProvider } from '@atlaskit/link-provider';
import type { ProductType } from '@atlaskit/linking-common';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const LinkingProviders = ({ children }: { children: React.ReactNode }) => {
	if (!fg('fun-1689_single_root_smart_card_provider')) {
		return children;
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { data } = useProjectContext();

	const product = getProductForSmartCardProvider(data);

	return (
		<SmartCardProvider product={product} isAdminHubAIEnabled={data?.isAIEnabled ?? false}>
			{children}
		</SmartCardProvider>
	);
};

const getProductForSmartCardProvider = (
	project: ProjectContext | null | undefined,
): ProductType | undefined => {
	switch (project?.projectType) {
		case 'software':
			return 'JSW';
		case 'business':
			return 'JWM';
		case 'service_desk':
			return 'JSM';
		case 'product_discovery':
			return 'JPD';
		default:
			return undefined;
	}
};
